import { render, staticRenderFns } from "./document-download.vue?vue&type=template&id=5084e30c&"
import script from "./document-download.vue?vue&type=script&lang=js&"
export * from "./document-download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports